import axios from "axios";
import { validateCaseDataSync } from "./formSchema";
import { storeCaseAdditionalInfoData, storeCaseInfoData } from "../redux/actions/caseInfo";
import { changeAddCaseFormStep, preProcessedMedicalRecordsData, storeLiablityEstern } from "../redux/actions/liabilty";
import { storeMedicalProvider } from "../redux/actions/medicalProviders";
import { storePainAndSufferingData } from "../redux/actions/painAndSuffering";
import { storeEconomicDamage } from "../redux/actions/economicDamage";
import * as pdfjsLib from 'pdfjs-dist/build/pdf';
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry';
pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;
export const getDefendantId = (defendant)=>{
    return defendant?.defendantId;
}

export const setDefendantId = (defendant, id)=>{
    if(defendant==null){
        return null;
    }
    if(id==null){
        defendant.defendantId = generateRandomIds();
    }
    else{
        defendant.defendantId = id;
    }
}

export const getDefendantName = (defendant)=>{
    if(defendant?.name){
        return defendant.name;
    }
    else{
        return defendant?.personalInfo?.name;
    }
}

export const getAuthtoken = () => {
    const authToken = getLocalStorageItem("authtoken")
    return authToken
};

export const getLocalStorageItem = (key) => {
    const val = localStorage.getItem(key)
    return val
};

export const removeSpecialCharacters = (str, charsToRemove = `!"#$%&'()*+,-./:;<=>?@[\\]^_\`{|}~`) => {
    const escapedChars = charsToRemove.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
    const regex = new RegExp(`[${escapedChars}]`, 'g');
    return str.replace(regex, '');
}

export const separateFilenameAndExtension = (filename) => {
    const lastDotIndex = filename.lastIndexOf('.');
    if (lastDotIndex === -1) {
        return { name: filename, ext: '' };
    }
    const name = filename.slice(0, lastDotIndex);
    const ext = filename.slice(lastDotIndex + 1);
    return { name, ext };
}

export function debounce(func, delay) {
    let timeoutId;

    return function (...args) {
        clearTimeout(timeoutId);

        timeoutId = setTimeout(() => {
            func.apply(this, args);
        }, delay);
    };
}


export const getNestedValue = (object, path, defaultValue) => {
    if (object == null) return defaultValue;
    const keys = Array.isArray(path)
        ? path
        : path.replace(/\[(\d+)\]/g, '.$1').split('.');

    let result = object;
    for (const key of keys) {
        if (result == null) return defaultValue;

        result = result[key];
    }

    return result === undefined ? defaultValue : result;
};


export const postMedicalRecords = (injuryData, caseId) => {
    return injuryData?.postAccident?.flatMap(providerLevel => {
        const providerName = providerLevel?.providerName;
        const medicalType = providerLevel?.medicalType || 'All Other Medical Records';

        return providerLevel?.medicalRecords?.map(file => {
            const blob = new Blob([file], { type: file.type });
            const newFile = new File([blob], file.name, { type: file.type });

            return {
                ...(!file?.s3UrlPath && { file: newFile }),
                ...(file?.s3UrlPath && { ...file }),
                metaData: {
                    providername: providerName,
                    medicaltype: medicalType,
                    originalfilename: file.name,
                    typeofrecord: 'postMedicalRecords',
                    ...(file?.s3UrlPath && { caseId }),
                }
            };
        }) || [];
    });
}


export const postMedicalBills = (injuryData) => {
    return injuryData?.postAccident?.flatMap(providerLevel => {
        const providerName = providerLevel?.providerName;
        const medicalType = providerLevel?.medicalType || 'All Other Medical Records';

        return providerLevel?.medicalBills?.map(file => {
            const blob = new Blob([file], { type: file.type });
            const newFile = new File([blob], file.name, { type: file.type });

            return {
                file: newFile,
                metaData: {
                    providername: providerName,
                    medicaltype: medicalType,
                    originalfilename: file.name,
                    typeofrecord: 'postMedicalBills'
                }
            };
        }) || [];
    });
}

export const preMedicalRecords = (injuryData, caseId) => {
    return injuryData?.preAccident?.flatMap(providerLevel => {
        const providerName = providerLevel?.providerName;
        const medicalType = providerLevel?.medicalType || 'All Other Medical Records';

        return providerLevel?.medicalRecords?.map(file => {
            const blob = new Blob([file], { type: file.type });
            const newFile = new File([blob], file.name, { type: file.type });

            return {
                ...(!file?.s3UrlPath && { file: newFile }),
                ...(file?.s3UrlPath && { ...file }),
                metaData: {
                    providername: providerName,
                    medicaltype: medicalType,
                    originalfilename: file.name,
                    typeofrecord: 'preMedicalRecords',
                    ...(file?.s3UrlPath && { caseId }),
                }
            };
        }) || [];
    });
}

export const setCookie = (name, value, days = 7) => {
    const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
    document.cookie = `${name}=${value}; expires=${expires}; path=/`;
};

export const getCookie = (name) => {
    const cookies = document.cookie.split(';');
    for (let cookie of cookies) {
        const [cookieName, cookieValue] = cookie.split('=').map(c => c.trim());
        if (cookieName === name) {
            return cookieValue;
        }
    }
    return null;
}

export const deleteCookie = (name) => {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
}

export const getLoggedInUserData = () => {
    const token = getAuthtoken()
    const parts = token.split('.');
    const payload = JSON.parse(window.atob(parts[1]));
    return payload;
}

export const generateRandomIds = () => {
    const randomDigits = Math.floor(10000 + Math.random() * 9000000000);
    return String(randomDigits);
}

export const sanitizeCaseFormData = (data, schema) => {
    if (Array.isArray(schema)) {
        return sanitizeArray(data, schema);
    }

    const sanitized = {};
    for (const key in schema) {
        const defaultValue = schema[key];
        const value = data?.[key];

        if (Array.isArray(defaultValue)) {
            sanitized[key] = sanitizeArray(value, defaultValue);
        } else if (typeof defaultValue === "object" && defaultValue !== null && !Array.isArray(defaultValue)) {
            sanitized[key] = sanitizeCaseFormData(value || {}, defaultValue);
        } else {
            sanitized[key] = sanitizePrimitive(value, defaultValue);
        }
    }
    return sanitized;
};

const sanitizePrimitive = (value, originalValue) => {
    const expectedType = typeof originalValue;

    if (expectedType === "string") {
        return value != null ? String(value) : "";
    }

    if (expectedType === "number") {
        const num = Number(value);
        return isNaN(num) ? 0 : num;
    }

    if (expectedType === "boolean") {
        if (typeof value === "string") {
            return value.toLowerCase() === "true" || value === "1";
        }
        return Boolean(value);
    }

    return value != null ? value : originalValue;
};

const sanitizeArray = (formValueArray, schemaArray) => {
    if (!Array.isArray(schemaArray)) return [];

    const schemaObject = schemaArray[0];
    if (typeof schemaObject !== "object") {
        return Array.isArray(formValueArray)
            ? formValueArray.map(val => sanitizePrimitive(val, schemaObject))
            : [];
    }

    if (!Array.isArray(formValueArray)) return [];

    const sanitized = formValueArray.map(item =>
        sanitizeCaseFormData(item, schemaObject)
    );

    if ('text' in schemaObject && typeof schemaObject.text === 'string') {
        const hasNonEmptyText = sanitized.some(obj => obj?.text?.trim());
        return hasNonEmptyText ? sanitized : [];
    }
    return sanitized;
};


export const isPdfPasswordProtect = async (file) => {
    const arrayBuffer = await file.arrayBuffer();
    try {
        await pdfjsLib.getDocument({
            data: arrayBuffer,
            password: '',
        }).promise;

        return false;
    } catch (err) {
        if (err.name === 'PasswordException') {
            return true;
        }
    }
};

export const validationFilesFunc = async (files, setFileErrorList) => {
   
    const errorList = [];
    const validFiles = [];

    for (const item of files) {
        const isProtected = await isPdfPasswordProtect(item);
        if (item.size === 0) {
            errorList.push({
                fileName: item?.name,
                fileSize: item.size
            });
            continue;
        }

        if (item.size > (500 * 1024 * 1024)) {
            errorList.push({
                fileName: item?.name,
                fileSize: item.size,
                isFileLarge: true
            });
            continue;
        }

        if (item.type !== "application/pdf") {
            errorList.push({
                fileName: item?.name,
                fileTypeError: true
            });
            continue;
        }

     if (isProtected) {
           errorList.push({
                fileName: item?.name,
                isPasswordProtected: true
            });
            continue;
        }

        validFiles.push(item);
    }

    if (errorList?.length) {
        setFileErrorList(errorList);
    }

    return validFiles;
};


export async function withRetry(fn, maxRetries = 3, initialDelay = 100) {
    let retries = 0;
    while (true) {
        try {
            return await fn();
        } catch (error) {
            retries++;
            if (retries >= maxRetries) {
                console.error(`Failed after ${maxRetries} retries:`, error);
                throw error;
            }
            // Exponential backoff
            const delay = initialDelay * Math.pow(2, retries);
            await new Promise(resolve => setTimeout(resolve, delay));
        }
    }
}

const filterLiabilityFiles = (liabilityEntry) => {
    if (Array.isArray(liabilityEntry)) {
        return liabilityEntry.reduce((acc, elem) => {
            if (elem.s3UrlPath) {
                acc.push({
                    defendants: elem.defendants,
                    name: elem.name,
                    s3UrlPath: elem.s3UrlPath
                });
            } else if (elem.text !== "") {
                acc.push(elem);
            }
            return acc;
        }, []);
    } else {
        return liabilityEntry;
    }
}

const castEconomicDamageValues = (ecoDamage)=>{
    ecoDamage.workHoursMissed = parseFloat(ecoDamage.workHoursMissed) || 0.0;
    ecoDamage.hourlyIncomeRate = parseFloat(ecoDamage.hourlyIncomeRate) || 0.0;
    return ecoDamage;
}

const buildClientsObjectForCaseData = (clientPersonalInfo, medicalProviders, economicDamages, painAndSuffering) => {
    if (clientPersonalInfo.length !== medicalProviders.length) {
        throw RangeError(`A medicalProviders object must be supplied for each client.\nClients: ${clientPersonalInfo} \nmedicalProviders: ${medicalProviders}`);
    }

    if (clientPersonalInfo.length !== economicDamages.length) {
        throw RangeError(`An economicDamages object must be supplied for each client.\nClients: ${clientPersonalInfo}, \neconomicDamages: ${economicDamages}`);
    }
    if (clientPersonalInfo.length !== painAndSuffering.length) {
        throw RangeError(`A painAndSuffering object must be supplied for each client.\nClients: ${clientPersonalInfo}, \npainAndSuffering: ${painAndSuffering}`);
    }
    return clientPersonalInfo.map((personalInfo, index) => {
        const client = {};
        client.clientId = personalInfo.clientId;
        client.insurance = personalInfo.insurance;
        client.personalInfo = personalInfo.personalInfo;
        client.medicalProviders = medicalProviders[index];
        client.damage = castEconomicDamageValues(economicDamages[index]);
        client.painAndSuffering = painAndSuffering[index];
        client.personalInfo.age = parseInt(client.painAndSuffering.age, 10) || 0;
        client.personalInfo.gender = client.painAndSuffering.gender || "Male";
        return client;
    });
};

export const transformFormDataToCaseData = (formData) => {
    try {
        let { caseInfo, liability, medicalProviders, damage, painAndSuffering } = formData || {};
        console.log("Transforming formdata:\n", formData);
        let cloneLiability = structuredClone(liability);
        for (const key in cloneLiability) {
            if (Object.prototype.hasOwnProperty.call(cloneLiability, key)) {
                cloneLiability[key] = filterLiabilityFiles(cloneLiability[key]);
            }
        }

        const caseData = {
            s3UniqueId: formData.s3UniqueId,
            caseInfo: {
                ...caseInfo.caseInfo,
                caseId: formData.caseId || null,
                processCase: formData.damage?.processCase,
            },
            clients: buildClientsObjectForCaseData(caseInfo.clients, medicalProviders, damage.ecoDamage, painAndSuffering),
            defendants: caseInfo.defendants,
            liability: cloneLiability,
            isDraftCase: formData.isDraftCase || false,
            isSaveCaseProgress: formData.isSaveCaseProgress,
            teamIds: caseInfo.teamIds || [],
        };

        const caseDataValidated = validateCaseDataSync(caseData);
        if (caseDataValidated.isValid) {
            return caseDataValidated.data
        }
        else {
            console.error("Produced invalid case data:\n", caseDataValidated.errors, '\n', caseDataValidated.data);
        }


    } catch (e) {
        console.error("Unable to convert formData to caseData: ", e);
        return formData;
    }
};

export const putFileToS3 = async (preSignedUrl, file, updateCaseFileUploadProgress) => {
    const res = await axios.put(preSignedUrl.signedUrl, file, {
        headers: { 'Content-Type': file?.type },
        onUploadProgress: (event) => {
            updateCaseFileUploadProgress(file, event.loaded, event.total);
        }
    });
    if (res.status === 200) return preSignedUrl;
    throw new Error("Upload failed with status " + res.status)
}

export function createMedicalObject(medicalProviders = []) {
    const result = {
        postAccident: [],
        preAccident: []
    };

    medicalProviders.forEach(elem => {
        const post = elem?.postAccident.medicalRecords?.filter(e => e?.providerName) || [];
        const pre = elem?.preAccident.medicalRecords?.filter(e => e?.providerName) || [];

        result.postAccident.push(post);

        result.preAccident.push(pre);
    });
    return result;
}

export const clearStoredGlobalState = (dispatch) => {
  dispatch(storeCaseAdditionalInfoData({}));
  dispatch(storeCaseInfoData({}));
  dispatch(storeLiablityEstern({}));
  dispatch(storeMedicalProvider({ medicalFiles: [] }));
  dispatch(storePainAndSufferingData({ painAndSufferingArr: [] }));
  dispatch(storeEconomicDamage({}));
  dispatch(preProcessedMedicalRecordsData({}));
  dispatch(changeAddCaseFormStep(0));
};